import { UserStatus } from 'src/@types/user-status';

type statusOptions = {
  label: string;
  icon: string;
  color?: string;
  value: UserStatus;
};

export const STATUS: statusOptions[] = [
  {
    label: 'online',
    icon: 'fluent-emoji-flat:green-circle',
    value: UserStatus.ONLINE,
  },
  {
    label: 'away',
    icon: 'fluent:presence-away-10-filled',
    color: '#ffab00',
    value: UserStatus.AWAY,
  },
  {
    label: 'invisible',
    icon: 'fa:circle-o',
    color: '#919eab',
    value: UserStatus.INVISIBLE,
  },
  {
    label: 'not_disturb',
    icon: 'ic:round-do-not-disturb-on',
    color: '#ff5630',
    value: UserStatus.OFFLINE,
  },
];
